export type PerspectiveColor = 'secondary' | 'primary' | 'error' | 'info';

/** App-wide fallback when there is no active perspective or the name is unknown. */
export const DEFAULT_PERSPECTIVE_COLOR: PerspectiveColor = 'primary';

/** Single source of truth: perspective name -> theme color. */
export const perspectiveColor: Record<string, PerspectiveColor> = {
  Veiligheid: 'secondary',
  GHOR: 'primary',
  Brandweer: 'error',
  Politie: 'info',
};

export function colorForPerspective(name: string | null | undefined): PerspectiveColor {
  return (name != null ? perspectiveColor[name] : undefined) ?? DEFAULT_PERSPECTIVE_COLOR;
}
